import React from 'react';
import classes from './averageReviewCard.module.css';

const AverageReviewCard = ({ averageReview }) => {
    return (
        <div className={classes.Container}>
            <img
                className={classes.Image}
                src={averageReview.icon}
                alt={averageReview.webSite}
            />
            <div className={classes.WebSite}>{averageReview.webSite}</div>
            <img src={averageReview.rateImg} alt='stars' className={classes.RateImg}/>
            <div className={classes.Rate}>{averageReview.rate}</div>
        </div>
    );
};

export default AverageReviewCard;
